import type { MockupLogo } from '../types/mockupLogos';

/**
 * Return true when the selected logo updates the region.
 * @param prevLogos - Prev logos state.
 * @param nextLogos - Next logos state.
 * @param selection - Current logo selection ID.
 */
export const isRegionUpdateOnSelection = (
  prevLogos: Readonly<MockupLogo[]>,
  nextLogos: Readonly<MockupLogo[]>,
  selection: string | undefined,
) => {
  if (!selection) return false;

  const prevLogo = prevLogos.find(l => l.id === selection);
  const nextLogo = nextLogos.find(l => l.id === selection);

  if (prevLogo && nextLogo) {
    return prevLogo.region !== nextLogo.region;
  }

  return false;
};
